import { Action } from '@ngrx/store';
import { Notification } from '@app/models/notification';

export enum NotificationActionTypes {
  Load = '[AP] Load notifications',
  LoadSuccess = '[API] Load notifications success',
  LoadFail = '[API] Load notifications fail',
  AddAll = '[Notifications] Add all',
  AddOne = '[Notifications] Add one',
  UpdateCounter = '[Notification] Update Counter',
  Update = '[API] Update notifications',
  UpdateSuccess = '[Notification] Update notifications success',
  UpdateFail = '[Notification] Update notifications fail',
  UpdateOne = '[Notification] Update one'
}

export class Load implements Action {
  readonly type = NotificationActionTypes.Load;
  constructor() {}
}

export class LoadSuccess implements Action {
  readonly type = NotificationActionTypes.LoadSuccess;
  constructor(public notifications: Notification[]) {}
}

export class LoadFail implements Action {
  readonly type = NotificationActionTypes.LoadFail;
  constructor(public error: any) {}
}

export class AddAll implements Action {
  readonly type = NotificationActionTypes.AddAll;
  constructor(public notifications: Notification[]) {}
}

export class AddOne implements Action {
  readonly type = NotificationActionTypes.AddOne;
  constructor(public notification: Notification) {}
}

export class UpdateCounter implements Action {
  readonly type = NotificationActionTypes.UpdateCounter;
  constructor(public count: number) {}
}

export class Update implements Action {
  readonly type = NotificationActionTypes.Update;
  constructor(public id: number, public notification: any) {}
}
export class UpdateFail implements Action {
  readonly type = NotificationActionTypes.UpdateFail;
  constructor(public error: any) {}
}

export class UpdateSuccess implements Action {
  readonly type = NotificationActionTypes.UpdateSuccess;
  constructor(public data: any) {}
}

export class UpdateOne implements Action {
  readonly type = NotificationActionTypes.UpdateOne;
  constructor(public notification: Notification) {}
}

export type NotificationActionsUnion =
  | Load
  | LoadSuccess
  | LoadFail
  | AddAll
  | AddOne
  | UpdateCounter
  | Update
  | UpdateSuccess
  | UpdateFail
  | UpdateOne;
